import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function DisposeOfPropertyInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        When do you dispose of a property for tax purposes?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          You are considered to have disposed of the property if, at any time
          during the year, you no longer treated it as a rental for tax
          purposes. This affects how you report your rental activity for the
          year.
        </p>
        <p>
          You should select &quot;Yes&quot; if, during the year, your property:
        </p>
        <ul>
          <li>Was sold</li>
          <li>Was transferred or gifted to someone else</li>
          <li>
            Was converted to personal use (for example, you moved in or began
            using it only for yourself)
          </li>
          <li>
            Was converted to a different use (like switching from rental to
            business use)
          </li>
          <li>Was destroyed, became unusable, and is no longer a rental.</li>
        </ul>
        <p>Select &quot;No&quot; if your property:</p>
        <ul>
          <li>Remained a rental, even if it was vacant part of the year</li>
          <li>
            Was under repairs, renovations, or maintenance, but you intend to
            keep renting it
          </li>
          <li>Had temporary changes but continues as a rental</li>
        </ul>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Publication 527 (2024), Residential Rental Property',
              url: 'https://www.irs.gov/publications/p527',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
